// Mirrors Volo.Abp.SettingManagement.SettingManagementPermissions (group
// "SettingManagement"). Only the groups the tenant admin is granted are used.
export const SettingManagementPermissions = {
  emailing: 'SettingManagement.Emailing',
  emailingTest: 'SettingManagement.Emailing.Test',
  timeZone: 'SettingManagement.TimeZone',
} as const;
